import { supabase } from '../../providers/supabase/client'
import { OperatorTable } from "../../util/interfaces";

export const fetchOperators = async () => {
    return await supabase
        .from('providers')
        .select('*')
}

export const createOperator = async (operator: OperatorTable) => {
    return await supabase
        .from('providers')
        .insert([operator])
        .select('*')
}

export const updateOperator = async (id: number, operator: OperatorTable) => {
    return await supabase
        .from('providers')
        .update(operator)
        .eq('id', id)
        .select('*')
}

export const deleteOperator = async (id: number) => {
    return await supabase
        .from('providers')
        .delete()
        .eq('id', id)
}

export const uploadProviderLogo = async (providerId: number, file: File): Promise<string | null> => {
    // Use a fixed path so re-uploads always overwrite the same object
    const path = `${providerId}/logo`

    const { error } = await supabase.storage
        .from('provider-logos')
        .upload(path, file, {
            upsert: true,
            contentType: file.type,
            cacheControl: '0',
        })

    if (error) {
        console.error('Error uploading provider logo:', error)
        return null
    }

    const { data: urlData } = supabase.storage
        .from('provider-logos')
        .getPublicUrl(path)

    // Append cache-busting timestamp so the browser always fetches the new image
    return urlData?.publicUrl ? `${urlData.publicUrl}?t=${Date.now()}` : null
}
